export default {"src":"/blog/_next/static/media/current_language.01b24163.svg","height":13,"width":18};